import React from "react";
import { motion } from "framer-motion";
import { Truck, Package, ShieldCheck, CreditCard, BadgeCheck } from "lucide-react";

const ITEMS = [
  { icon: BadgeCheck, label: "Revendeur certifié Frigidaire & Vesta · Montréal", color: "bg-brand-red" },
  { icon: Truck, label: "Livraison à domicile", color: "bg-emerald-600" },
  { icon: Package, label: "Livraison gratuite (30 km)", color: "bg-brand-navy" },
  { icon: ShieldCheck, label: "Garantie 1 an", color: "bg-emerald-600" },
  { icon: CreditCard, label: "Financement disponible", color: "bg-brand-navy" },
  { icon: Truck, label: "Livraison & transport même sans achat (frais applicables)", color: "bg-emerald-600" },
];

export const AnnouncementBar = () => {
  const loop = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <div className="w-full overflow-hidden text-white" data-testid="announcement-bar">
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-33.333%"] }}
        transition={{ duration: 14, ease: "linear", repeat: Infinity }}>
        {loop.map((it, i) => (
          <div key={i} className={`flex items-center gap-2 px-6 py-2 text-xs font-semibold tracking-wide ${it.color}`}>
            <it.icon size={15} className="shrink-0" />
            {it.label}
          </div>
        ))}
      </motion.div>
    </div>
  );
};
